import request from '@/common/utils/request'
// import { LogRequestModel, LogResponseModel } from './model/LogModel.js'
// 打点上报服务
export function logReport (data) {
  return request({
    url: process.env.HTTP_SERVER + 'receive/samplingreceiver/receivedata',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/data/api/common/Log/Log.js